import { ShoppingBag, MessageCircle } from "lucide-react";
import { useCart } from "@/components/CartContext";

const LOGO_URL = "https://customer-assets-eiarnc6j.emergentagent.net/job_dc1f59b0-d4ed-4a52-be65-0a28e94c6aa3/artifacts/1mrurg75_image.png";
const FACEBOOK_URL = "https://www.facebook.com/groups/1112257584339430";

export default function Nav({ onBrandClick }) {
  const { count, setOpen } = useCart();
  return (
    <header className="sticky top-0 z-40 border-b-2 border-[#0A0A0A] bg-[#FDFBF7]/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
        <a href="#top" onClick={onBrandClick} data-testid="nav-brand-link" className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="Canadian Beats Marketplace"
            className="h-10 w-10 rounded-md border-2 border-[#0A0A0A] object-cover"
          />
          <span className="flex flex-col leading-tight">
            <span className="font-display text-sm font-extrabold uppercase tracking-tight sm:text-base">
              Canadian Beats <span className="text-[#FF2A54]">Marketplace</span>
            </span>
            <span data-testid="nav-descriptor" className="hidden font-display text-[10px] font-bold uppercase tracking-[0.2em] text-[#4A4A4A] sm:block">
              Candy &bull; Toys &bull; Trending Stuff
            </span>
          </span>
        </a>
        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-contact-button"
            className="hard-shadow hard-shadow-hover hidden items-center gap-1.5 rounded-full border-2 border-[#0A0A0A] bg-white px-4 py-1.5 font-display text-xs font-extrabold uppercase tracking-wide sm:inline-flex"
          >
            <MessageCircle className="h-3.5 w-3.5 text-[#FF2A54]" /> Contact
          </a>
          <button
            onClick={() => setOpen(true)}
            data-testid="nav-cart-button"
            aria-label="Open cart"
            className="hard-shadow hard-shadow-hover relative rounded-full border-2 border-[#0A0A0A] bg-white p-2.5"
          >
            <ShoppingBag className="h-4 w-4" />
            {count > 0 && (
              <span data-testid="nav-cart-count"
                className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full border-2 border-[#0A0A0A] bg-[#FF2A54] font-display text-[10px] font-extrabold text-white">
                {count}
              </span>
            )}
          </button>
          <a
            href="#shop"
            data-testid="nav-shop-now-button"
            className="hard-shadow hard-shadow-hover whitespace-nowrap rounded-full border-2 border-[#0A0A0A] bg-[#FFD700] px-4 py-1.5 font-display text-xs font-extrabold uppercase tracking-wide text-[#0A0A0A]"
          >
            Shop Now
          </a>
        </div>
      </div>
    </header>
  );
}
